import { eThongKeSoLuongSinhVienActionsObj } from "../../action-types/bao-cao/IThongKeSoLuongSinhVienActions";
import { generateActions } from "../generateActions";

export const thongKeSoLuongSinhVienActions = {
  ...generateActions(eThongKeSoLuongSinhVienActionsObj, "THONG_KE_SL_SINH_VIEN"),
};
